// extracted by mini-css-extract-plugin
export var result = "style-module--result--9ca76";
export var result_col = "style-module--result_col--61e62";
export var result_colItemName = "style-module--result_col-item--name--30c0b";
export var result_colItem_header = "style-module--result_col-item_header--66bc2";
export var result_colItem_headerIcon = "style-module--result_col-item_header--icon--11ed5";
export var result_colItem_headerIcon_special = "style-module--result_col-item_header--icon_special--4f19e";
export var result_row = "style-module--result_row--2a9f9";
export var result_title = "style-module--result_title--7ee97";